// 初始化逻辑
export const logicalSettings = (q) => {
    // console.log(q.questionsTypeId)
	if (q.questionsTypeId != '26') {
		let jumpTypeList = ['6', '8', '9', '10', '12', '38']
		if (jumpTypeList.indexOf(q.questionsTypeId) !== -1) {
			q.logicalSettings = {
				num: 0,
				jump: { // 跳转条件
					type: 0, // 0无条件 1选择某一项
					logicList: []
				},
				show: [
					// 	{ // 显示条件
					// 	condition: 1, // 1 全部 2 任意
					// 	conditionList: [{
					// 		questionId: '', // 题目
					// 		questionState: 3, // 题目状态
					// 	}]
					// }
				],
				quesBound: [], // 绑定显示条件的试题
			}
		} else if (q.questionsTypeId == '25'){
			q.logicalSettings = {
				num: 0,
				show: [
					// { // 显示条件
					// 	condition: 1, // 1 全部 2 任意
					// 	conditionList: [{
					// 		questionId: '', // 题目
					// 		questionState: 3, // 题目状态
					// 	}]
					// }
				],
				quesBound: [], // 绑定显示条件的试题
			}
		}else {
			
			q.logicalSettings = {
				num: 0,
				jump: {
					type: 0, // 0无条件 1选择某一项
					logicList: []
				},
				show: [
					// { // 显示条件
					// 	condition: 1, // 1 全部 2 任意
					// 	conditionList: [{
					// 		questionId: '', // 题目
					// 		questionState: 3, // 题目状态
					// 	}]
					// }
				],
				quesBound: []
			}
		}
	}
    return q
}